import { ArrowLeft, Menu, ShieldCheck } from "lucide-react";

export default function AdminHeader({ onExitAdmin, onOpenMenu, user }) {
  const initials = user?.full_name
    ? user.full_name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "AD";

  return (
    <header className="sticky top-0 z-40 bg-[#030A17]/95 backdrop-blur-md border-b border-white/10 px-3 sm:px-4 py-2.5 pt-[calc(0.625rem+env(safe-area-inset-top))]">
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-2">
        {/* Left: Exit Admin */}
        <button
          type="button"
          onClick={onExitAdmin}
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 active:scale-95 transition-all text-xs font-semibold text-slate-300 hover:text-white cursor-pointer"
          aria-label="Exit Admin"
          data-testid="exit-admin-btn"
        >
          <ArrowLeft className="w-3.5 h-3.5 text-sky-400 shrink-0" />
          <span>Exit Admin</span>
        </button>

        {/* Center: Branding */}
        <div className="flex flex-col items-center justify-center text-center select-none">
          <span className="text-[10px] font-bold tracking-widest text-slate-400 uppercase leading-none">
            TA FITNESS
          </span>
          <span className="text-xs sm:text-sm font-black tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-cyan-300 to-sky-400 uppercase leading-tight">
            ADMIN PORTAL
          </span>
        </div>

        {/* Right: Shield / Avatar & Menu trigger */}
        <div className="flex items-center gap-2">
          <div
            className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-sky-950/40 border border-sky-400/30 text-sky-400"
            title={`Logged in as ${user?.full_name || "Administrator"}`}
          >
            <ShieldCheck className="w-3.5 h-3.5 text-sky-400" />
            <span className="text-[10px] font-bold uppercase tracking-wider hidden sm:inline">
              Admin
            </span>
            <div className="w-5 h-5 rounded-full bg-sky-500/20 border border-sky-400/40 flex items-center justify-center text-[10px] font-bold text-sky-300">
              {initials}
            </div>
          </div>

          <button
            type="button"
            onClick={onOpenMenu}
            className="p-1.5 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 active:scale-95 transition-all text-slate-300 hover:text-white cursor-pointer"
            aria-label="Admin Navigation Menu"
            data-testid="admin-menu-btn"
          >
            <Menu className="w-4 h-4 text-sky-400" />
          </button>
        </div>
      </div>
    </header>
  );
}
